export enum ProductGalleryStyleV2Type {
  PRODUCT_GALLERY_MODAL = 'PRODUCT_GALLERY_MODAL',
  DEFAULT = 'DEFAULT',
}

export enum SwipeEnum {
  LEFT = 'left',
  RIGHT = 'right',
  NONE = 'none',
}

export enum MediaType {
  VIDEO = 'video',
  IMAGE = 'image',
}

export enum SelectorIdEnum {
  HERO_GALLERY_SLIDES = 'hero-gallery-slides',
  HERO_GALLERY_SLIDE = 'hero-gallery-slide',
  GALLERY_CONTAINER_INNER_SCROLL = 'gallery-container-inner-scroll',
}

export enum ScrollBehaviorEnum {
  SMOOTH = 'smooth',
  AUTO = 'auto',
}

export enum VisibilityEnum {
  VISIBLE = 'visible',
  HIDDEN = 'hidden',
}
